export default "__VITE_ASSET__CTGNbGkB__"